import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PickupService } from 'src/app/services/pickup.service';
import { StatusLogService } from 'src/app/services/status-log.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { MatDialog } from '@angular/material/dialog';
import { ScannerModalComponent } from 'src/app/scanner-modal/scanner-modal.component';

@Component({
  selector: 'app-picker-manual',
  templateUrl: './picker-manual.component.html',
  styleUrls: ['./picker-manual.component.scss'],
})
export class PickerManualComponent {
  screen_height: number = window.screen.height;
  screen_width: number = window.screen.width;

  c1_pos: any;
  c2_pos: any;
  c3_pos: any;
  c4_pos: any;
  c1: string = '';
  c2: string = '';
  c3: string = '';
  c4: string = '';

  is_bt: boolean = false;

  rackOptions = Array.from({ length: 26 }, (_, i) => ({
    key: String.fromCharCode(65 + i), // Genera letras A-Z
    value: `Rack ${String.fromCharCode(65 + i)}`, // Texto visible
  }));

  nivelOptions = Array.from({ length: 8 }, (_, i) => ({
    key: (i + 1).toString(),
    value: `Nivel ${(i + 1).toString()}`,
  }));

  posicionOptions = Array.from({ length: 20 }, (_, i) => ({
    key: (i + 1).toString(),
    value: `Posición ${(i + 1).toString()}`,
  }));

  zonaOptions = Array.from({ length: 26 }, (_, i) => ({
    key: String.fromCharCode(65 + i), // Genera letras A-Z
    value: `Zona ${String.fromCharCode(65 + i)}`, // Texto visible
  }));

  constructor(
    private router: Router,
    public pickupService: PickupService,
    public utilityService: UtilitiesService,
    private dialog: MatDialog,
    private statusService: StatusLogService
  ) {}

  ngOnInit() {
    if (this.pickupService.pedidoActivo.tipo == 'BT') this.is_bt = true;

    //   this.c1_pos = this.is_bt ? ['BT'] : this.zonaOptions; //this.getLetters();
    //   this.c2_pos = this.is_bt ? ['88'] : this.rackOptions;//this.getLetters();
    //   this.c3_pos = this.nivelOptions;//this.getNumbers();
    //  this.c4_pos = this.posicionOptions;//this.getNumbers();

    //  this.c1 = this.c1_pos[0];
    // this.c2 = this.c2_pos[0];
    //this.c3 = this.c3_pos[0];
    //  this.c4 = this.c4_pos[0];

    console.log(this.c1);
  }

  getLetters(): string[] {
    let letters: string[] = [];

    for (let i = 65; i <= 90; i++) {
      letters.push(String.fromCharCode(i));
    }

    return letters;
  }

  getNumbers(): string[] {
    let numbers: string[] = [];

    for (let i = 0; i <= 9; i++) {
      numbers.push(i.toString());
    }

    return numbers;
  }

  seleccionar() {
    this.pickupService.codigoPosicion = `${this.c1}${this.is_bt ? '-' : ''}${
      this.c2
    }-${this.c3}-${this.c4}`;

    //this.router.navigate(['/picker-manual-bultos']);
    this.router.navigate(['/opciones']);
  }

  escanearQr(): void {
    const dialogRef = this.dialog.open(ScannerModalComponent, {
      width: this.screen_width + 'px',
      height: this.screen_height + 'px',
      disableClose: false, // Evita que se cierre el modal al hacer clic afuera
    });

    dialogRef.afterClosed().subscribe((result: any | undefined) => {
      if (result) {
        this.c1 = result.c1;
        this.c2 = result.c2;
        this.c3 = result.c3;
        this.c4 = result.c4;
        this.pickupService.codigoPosicion = `${this.c1}${
          this.is_bt ? '-' : ''
        }${this.c2}-${this.c3}-${this.c4}`;
      } else {
        console.warn('No se capturó ningún QR.');
      }
    });
  }

  salir() {
    this.router.navigate(['/opciones']);
  }
}
